export default "__VITE_ASSET__9ee505aa__"